/* ImVita — shared interactions: sticky nav, scroll-reveal, parallax, counters */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- sticky nav shadow ---- */
  var nav = document.querySelector('header.nav');
  function onScrollNav() {
    if (!nav) return;
    nav.classList.toggle('stuck', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScrollNav, { passive: true });
  onScrollNav();

  /* ---- scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- parallax (rAF, transform-based) ---- */
  var pxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function motionOff() {
    return document.documentElement.getAttribute('data-motion') === 'off' || reduce;
  }
  function applyParallax() {
    ticking = false;
    if (motionOff()) { pxEls.forEach(function (el) { el.style.transform = ''; }); return; }
    var fac = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pfac')) || 1;
    var vh = window.innerHeight;
    pxEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var rel = (center - vh / 2) / vh;           /* -1..1 across viewport */
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
      var axis = el.getAttribute('data-axis') || 'y';
      var move = -rel * speed * 100 * fac;
      var rot = el.getAttribute('data-rot');
      var t = axis === 'x' ? 'translate3d(' + move + 'px,0,0)' : 'translate3d(0,' + move + 'px,0)';
      if (rot) t += ' rotate(' + (rel * parseFloat(rot)) + 'deg)';
      el.style.transform = t;
    });
  }
  function requestPx() { if (!ticking) { ticking = true; requestAnimationFrame(applyParallax); } }
  if (pxEls.length) {
    window.addEventListener('scroll', requestPx, { passive: true });
    window.addEventListener('resize', requestPx);
    applyParallax();
  }

  /* ---- count-up ---- */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; cio.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
        if (reduce) { el.textContent = target.toFixed(dec) + suffix; return; }
        var start = performance.now(), dur = 1400;
        function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---- mobile nav ---- */
  var toggle = document.querySelector('.nav__toggle');
  var drawer = document.querySelector('.mobile-drawer');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      document.body.style.overflow = open ? 'hidden' : '';
      toggle.setAttribute('aria-expanded', open);
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.classList.remove('open'); document.body.style.overflow = ''; });
    });
  }

  /* ---- before/after sliders ---- */
  document.querySelectorAll('[data-ba-thumbs]').forEach(function (row) {
    var scope = row.closest('.ba-grid') || row.parentElement;
    var card = scope ? scope.querySelector('[data-ba]') : null;
    if (!card) return;
    var beforeImg = card.querySelector('[data-ba-before]');
    var afterImg = card.querySelector('[data-ba-after]');
    row.querySelectorAll('.ba-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        row.querySelectorAll('.ba-thumb').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (beforeImg) beforeImg.src = btn.getAttribute('data-before');
        if (afterImg) afterImg.src = btn.getAttribute('data-after');
      });
    });
  });
  document.querySelectorAll('[data-ba]').forEach(function (el) {
    var handle = el.querySelector('.ba__handle');
    var top = el.querySelector('.ba__after');
    var dragging = false;
    function set(x) {
      var rect = el.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
      el.style.setProperty('--pos', pct + '%');
    }
    function down(e) { dragging = true; set((e.touches ? e.touches[0] : e).clientX); }
    function move(e) { if (dragging) set((e.touches ? e.touches[0] : e).clientX); }
    function up() { dragging = false; }
    el.addEventListener('mousedown', down); el.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move); window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up); window.addEventListener('touchend', up);
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('[data-faq]').forEach(function (item) {
    var q = item.querySelector('.faq__q');
    q.addEventListener('click', function () {
      var open = item.classList.toggle('open');
      var a = item.querySelector('.faq__a');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
    });
  });
  /* ---- rv-card photo carousel ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (el) {
    var track = el.querySelector('.rv-track');
    var slides = track.querySelectorAll('.rv-slide');
    var dotsWrap = el.querySelector('.rv-dots');
    var i = 0;
    el.setAttribute('data-count', slides.length);
    slides.forEach(function (s, n) {
      var d = document.createElement('span'); if (n === 0) d.className = 'on'; dotsWrap.appendChild(d);
    });
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dotsWrap.querySelectorAll('span').forEach(function (d, n2) { d.classList.toggle('on', n2 === i); });
    }
    var prev = el.querySelector('.rv-prev'), next = el.querySelector('.rv-next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
  });
})();
